import React from "react";
import { useSearchParams } from "react-router-dom";
import ResetPasswordForm from "../organisms/ResetPasswordForm";

const PasswordResetPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const id = searchParams.get("id");
  return (
    <div>
      <div>
        <ResetPasswordForm token={token} userId={id} />
      </div>
    </div>
  );
};

export default PasswordResetPage;
